import actions from "./actions";

const state = {
  loadLowList: [],
}

export default {
  namespaced: true,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/low/index.js